import React, { useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import { debugLogPages } from '../../app/helpers/debugHelper';
import {
    FaMicrochip, FaPuzzlePiece, FaStar, FaLightbulb,
    FaHeadset, FaChartLine, FaEye, FaShieldHalved
} from "react-icons/fa6";
import { startLoadingHomeContentItems } from '../../app/actions/homeContentActions';
import { HOME_CONTENT_TYPE_KEYS, pickHomeItems } from '../../app/helpers/homeContentHelper';

const MODULE_CONFIG = [
    { key: 'Technology', moduleKey: 'technology', border: 'primary', color: 'var(--accent-color1)', icon: <FaMicrochip /> },
    { key: 'Alternative', moduleKey: 'alternative', border: 'secondary', color: 'var(--accent-color1)', icon: <FaPuzzlePiece /> },
    { key: 'Experience', moduleKey: 'experience', border: 'success', color: 'var(--accent-color1)', icon: <FaStar /> },
    { key: 'Innovation', moduleKey: 'innovation', border: 'danger', color: 'var(--accent-color1)', icon: <FaLightbulb /> },
    { key: 'Assistance', moduleKey: 'assistance', border: 'warning', color: 'var(--accent-color1)', icon: <FaHeadset /> },
    { key: 'Financial', moduleKey: 'financial', border: 'info', color: 'var(--accent-color1)',  icon: <FaChartLine /> },
    { key: 'Vision', moduleKey: 'vision', border: 'dark', color: 'var(--accent-color1)', icon: <FaEye /> },
    { key: 'Regulation', moduleKey: 'regulation', border: 'primary', color: 'var(--accent-color1)', icon: <FaShieldHalved /> },
];

const InfoCard = ({ data, border, icon, color }) => {
    const { t } = useTranslation();
    return (
    <Card border={border} bg="light" className="bg-transparent card-container borde-cards-busqueda h-100">
        <Card.Header 
            className="tit-cards-internas row align-items-center text-white mx-0" 
            style={{ backgroundColor: color, borderBottom: 'none' }}
        >
            <div className="col-2 d-flex justify-content-center px-0">
                <div style={{ fontSize: '1.5rem', color: 'white' }}>
                    {icon}
                </div>
            </div>
            <div className="col-10 jutificado-izquierda font-weight-bold" style={{ fontSize: '0.9rem' }}>
                {data.title}
            </div>
        </Card.Header>
        <Card.Body className="d-flex flex-column">
            <Card.Title className="tit-interno-cards" style={{ fontSize: '0.95rem' }}>{data.reference}</Card.Title>
            <div className="read-more-container-text">
                <ReadMoreReadLess
                    buttonClassName='btn-read-more-less'
                    expandLabel={t('buttons.readMore', { defaultValue: 'Leer más' })}
                    collapseLabel={t('buttons.readLess', { defaultValue: 'Leer menos' })}
                    limit="300">
                    {data.text}
                </ReadMoreReadLess>
            </div>
        </Card.Body>
    </Card>
    );
};

const L2InformationModules = () => {
    debugLogPages(':: L2InformationModules');
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    const config = useSelector((state) => state.configuration);
    const { items } = useSelector((state) => state.homeContent);

    useEffect(() => {
        dispatch(startLoadingHomeContentItems());
    }, [dispatch]);

    const homeCards = pickHomeItems(items, HOME_CONTENT_TYPE_KEYS.INFO_CARDS, i18n.language);

    return (
        <div className='container-fluid mt-4 px-4'>
            <Row className="g-3">
                {MODULE_CONFIG.map(({ key, moduleKey, border, icon, color }) => {
                    const isEnabled = config[`searchModuleInformation${key}Enabled`] === "true";
                    const fromHome = homeCards.find((row) => String(row.module_key || '').toLowerCase() === moduleKey);
                    const data = fromHome
                        ? { title: fromHome.title, reference: fromHome.reference, text: fromHome.text }
                        : null;

                    if (!isEnabled || !data) return null;

                    return (
                        <Col key={key} xs={12} sm={6} md={3}>
                            <InfoCard
                                data={data}
                                border={border}
                                icon={icon}
                                color={color}
                            />
                        </Col>
                    );
                })}
            </Row>
        </div>
    );
};

export default L2InformationModules;
